import React from 'react';
import { ModalBackdrop } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { NotFoundView, SierraHostedFrame } from '../../components';
import { useNavigateBack } from '../../navigation';

export const ChatScreen = () => {
  const isSierraEnabled = useFeatureFlag('permanent-sierra-enabled');

  if (!isSierraEnabled) return <NotFoundView />;

  return <SierraChatScreen />;
};

const SierraChatScreen = () => {
  const navigateBack = useNavigateBack();

  return (
    <>
      <SierraHostedFrame onClose={navigateBack} />
      <ModalBackdrop onPress={navigateBack} />
    </>
  );
};
